export default "__VITE_ASSET__e8a62bb3__"